import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { buildModuleViewDeniedMessage } from '../config/module-access-error.util';

@Component({
  selector: 'app-vault-access-denied',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './vault-access-denied.component.html',
  styleUrls: ['./vault-access-denied.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'vault-access-denied-host',
  },
})
export class VaultAccessDeniedComponent {
  readonly moduleLabel = input.required<string>();
  readonly title = input('Acceso restringido');
  readonly message = input<string | null>(null);

  resolvedMessage(): string {
    return this.message() ?? buildModuleViewDeniedMessage(this.moduleLabel());
  }
}
